import script from "./showBoxUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./showBoxUpdate.vue?vue&type=script&setup=true&lang=js"

import "./showBoxUpdate.vue?vue&type=style&index=0&id=be2d3324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be2d3324"]])

export default __exports__